import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface LearnMoreProps {
  title: string;
  children: React.ReactNode;
}
export const LearnMore: React.FC<LearnMoreProps> = ({
  title,
  children
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="mt-4 print:hidden" data-id="element-377">
      <button onClick={() => setIsExpanded(!isExpanded)} className="flex items-center justify-center space-x-2 text-sm text-[#1E90FF] hover:text-[#1E90FF]/80 transition-colors font-medium w-full" type="button" data-id="element-378">
        <span data-id="element-379">{title}</span>
        {isExpanded ? <ChevronUpIcon className="h-4 w-4" data-id="element-380" /> : <ChevronDownIcon className="h-4 w-4" data-id="element-381" />}
      </button>
      <AnimatePresence data-id="element-382">
        {isExpanded && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="overflow-hidden" data-id="element-383">
            <div className="mt-3 p-4 bg-gray-50 rounded-lg border border-gray-200 text-sm text-gray-600 leading-relaxed" data-id="element-384">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};